import { useContext } from 'react';
import { ContentCanvasContext } from '../content-canvas-provider';
export default function useContentCanvas() {
  return useContext(ContentCanvasContext);
}